import React, { useRef, useState } from 'react';

// Small box at the left that tells everyone the meeting is recorded and transcribed.
// Anyone can drag it out of the way. The host also gets the reminder to stop the recording at the end.
export default function RecordingNotice({ isHost, isRecording }) {
  const [pos, setPos] = useState({ x: 12, y: 140 });
  const drag = useRef(null);

  const onPointerDown = (e) => {
    drag.current = { dx: e.clientX - pos.x, dy: e.clientY - pos.y };
    e.currentTarget.setPointerCapture(e.pointerId);
  };
  const onPointerMove = (e) => {
    if (!drag.current) return;
    setPos({
      x: Math.max(0, e.clientX - drag.current.dx),
      y: Math.max(0, e.clientY - drag.current.dy),
    });
  };
  const onPointerUp = () => { drag.current = null; };

  return (
    <div
      role="note"
      aria-label="Recording notice"
      style={{
        position: 'fixed', left: pos.x, top: pos.y, width: 240, zIndex: 1500,
        background: 'rgba(20,20,20,0.94)', color: '#fff', border: '1px solid #c62828',
        borderRadius: 8, boxShadow: '0 4px 14px rgba(0,0,0,0.4)', fontSize: 13, lineHeight: 1.4,
      }}
    >
      <div
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerUp}
        title="Drag to move"
        style={{ cursor: 'move', padding: '6px 10px', background: '#c62828', borderRadius: '7px 7px 0 0', fontWeight: 'bold', touchAction: 'none', userSelect: 'none' }}
      >
        Recording and transcribing
      </div>
      <div style={{ padding: '8px 10px' }}>
        <p style={{ margin: 0 }}>This meeting is being recorded and transcribed.</p>
        {isHost && <p style={{ margin: '6px 0 0' }}>Stop the recording at the end of the meeting.</p>}
        {isHost && !isRecording && (
          <p style={{ margin: '6px 0 0', color: '#ffb74d' }}>Recording has not started. Use the Start recording button.</p>
        )}
      </div>
    </div>
  );
}
